import { useMediaQuery } from '@mui/material';
export function useMediaQueryOrBoolean(value, defaultValue) {
    var isQueryMatched = useMediaQuery(typeof value === 'function' ? value : '');
    switch (typeof value) {
        case 'boolean':
            return value;
        case 'function':
            return isQueryMatched;
        case 'undefined':
        default:
            return defaultValue;
    }
}
